export const fontColours = {
  alto: "#d3d3d3",
  nobel: "#b5b5b5",
  pigeonPost: "#b4c4d8",
  blueHaze: "#bbc3da",
  fountainBlue: "#67A6BE",
  cyan: "#00d7ff"
};

export const backgroundColours = {
  jaggedIce: "#cbe0ec",
  cloudBurst: "#203244",
  lightMirage: "#192835",
  mirage: "#1a2835",
  darkMirage: "#1a212f",
  ebonyClay: "#222838",
  bluewood: "#2c344e",
  purpleWood: "#2a3e53",
  rhino: "#304863",
  sanJuan: "#29506f",
  cello: "#21415a",
  darkCello: "#1e3b52",
  calypso: "#2c5f88",
  eastBay: "#3b4873",
  kashmirBlue: "#495c9a",
  martinique: "#333550",
  curiousBlue: "#3495d9",
  transparentMirage: `rgba(26, 40, 53, 0.93)`,
  transparent: `rgba(0, 0, 0, 0)`,
  transparentLightGrey: `rgba(255, 255, 255, 0.1)`,
  transparentGrey: `rgba(255, 255, 255, 0.5)`
};

export const boxShadowColours = {
  purpleInset: "box-shadow: inset 0 0 10px 10px #40415e",
  largeInset: "inset 0 0 400px -150px",
  lightBottom: `0 6px 7px 2px rgba(0, 0, 0, 0.2)`,
  blueMound: `2.5px 2.5px 3.5px 1px #1a2b3c,
  inset -2.5px -2.5px 3.5px 1px #1a2b3c, 5px 5px 5px 7.5px #1d3040,
  inset 10px 10px 7.5px -7.5px #243a4c`
};
